import { useRef, useLayoutEffect } from 'react';

interface FlipItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  itemId: string;
  deps?: any[];
  shouldAnimate?: boolean;
}

function FlipList({
  children,
  itemId,
  deps = [],
  shouldAnimate = true,
  ...props
}: FlipItemProps) {
  const ref = useRef<HTMLDivElement>(null);
  const prevRect = useRef<DOMRect | null>(null);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return;
    const first = prevRect.current;
    const last = node.getBoundingClientRect();

    if (first && shouldAnimate) {
      // const dx = first.left - last.left;
      const dx = 0;
      const dy = first.top - last.top;
      if (dx !== 0 || dy !== 0) {
        node.style.transition = 'none';
        node.style.transform = `translate3d(${dx}px, ${dy}px, ${dy > 0 ? 10 : 0}px)`;
        void node.offsetHeight; // force reflow
        node.style.transition = 'transform 300ms cubic-bezier(0.4,0,0.2,1)';
        node.style.transform = '';
      }
    }
    prevRect.current = last;
    // eslint-disable-next-line
  }, [itemId, ...deps]);

  return (
    <div className="FlipList" ref={ref} {...props}>
      {children}
    </div>
  );
}

const MemoizedFlipList = memo(FlipList);

export { MemoizedFlipList as FlipList };
